customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          (this.form.querySelector("[name=id]").disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }
      onSubmitHandler(e) {
        e.preventDefault();
        const r = this.querySelector('[type="submit"]');
        if (r.classList.contains("loading")) return;
        this.handleErrorMessage(),
          r.setAttribute("aria-disabled", !0),
          r.classList.add("loading"),
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        const t = fetchConfig("javascript");
        (t.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete t.headers["Content-Type"];
        const s = new FormData(this.form);
        s.append("sections_url", window.location.pathname),
          (t.body = s),
          fetch(`${routes.cart_add_url}`, t)
            .then((e) => e.json())
            .then((e) => {
              e.status && this.handleErrorMessage(e.description);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              r.classList.remove("loading"),
                r.removeAttribute("aria-disabled"),
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                )
                // (location.href = "/cart");
            });
      }
      handleErrorMessage(e = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          (this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            )),
          this.errorMessageWrapper.toggleAttribute("hidden", !e),
          e && (this.errorMessage.textContent = e);
      }
    }
  );
